import Vue from 'vue'
import Vuex from 'vuex'
import snackbar from '@/store/modules/snackbar'
import loading from '@/store/modules/loading'
import session from '@/store/modules/session'
import turnos from '@/store/modules/turnos'
import parametro from '@/store/modules/parametro'
import websocket from '@/store/plugins/websocket'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    snackbar,
    loading,
    session,
    turnos,
    parametro
  },
  plugins: [websocket()],
  strict: debug
})
